<div display="dynamic"
     placement="bottom-end"
     ngbDropdown
     [autoClose]="'outside'">
  <button id="help"
          class="btn btn-primary"
          ngbDropdownToggle
          ngbTooltip="Help"
          placement="bottom"
          container="body"
          autoClose="outside"
          style="padding-right: 5px !important;">
    <i class="fa-light fa-bars"></i>
  </button>
  <div ngbDropdownMenu>
    <button ngbDropdownItem
            *ngFor="let dropdownItem of dropdownItems"
            [id]="dropdownItem.id"
            (click)="openNewTab(dropdownItem.url)">
      {{dropdownItem.name}}
    </button>
  </div>
</div>
